/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useEffect, useRef, useState } from "react";
import {
  Container,
  SearchInput,
  IconRightArrow,
  IconMagnifyingGlass
} from "./styles";



const Search = () => {
  const targetRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const showSearchInput = isHovered || isFocused;

  const SendToPage = (e) => {
    e.preventDefault();
    // @ts-ignore
    const searchQ = document.getElementById('nav-search').value;
    const newURL = '/search?search=' + searchQ;
    window.location.href = newURL;
  }
  
  useEffect(() => {
    targetRef.current.value = "";
  }, [showSearchInput]);

  return (
    <Container
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      hover={showSearchInput}
      onSubmit={(e) => SendToPage(e)}
    >
      <SearchInput id='nav-search' ref={targetRef} showSearchInput={showSearchInput} />
      {showSearchInput ? <IconRightArrow /> : <IconMagnifyingGlass id='magnifying-glass' />}
    </Container>
  );
}

export default Search;
